// composables/useYoutubeApi.ts
import load from 'load-script';
import { logger } from 'data-layer/exports';

declare global {
  interface Window {
    onYouTubeIframeAPIReady?: () => void;
    YT?: typeof YT;
  }
}

let ytApiPromise: Promise<typeof YT> | null = null;

export function useYoutubeApi(): Promise<typeof YT> {
  if (ytApiPromise) return ytApiPromise;

  ytApiPromise = new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      reject(new Error('YouTube API must be used on the client'));
      return;
    }

    if (window.YT?.Player) {
      resolve(window.YT);
      return;
    }

    load('https://www.youtube.com/iframe_api', (err) => {
      if (err) {
        logger.error('[YouTube] Failed to load script:', err);
        reject(err);
        return;
      }
    });

    window.onYouTubeIframeAPIReady = () => {
      if (window.YT) {
        resolve(window.YT);
      } else {
        reject(new Error('[YouTube] API did not load properly'));
      }
    };
  });

  return ytApiPromise;
}
